export default "__VITE_ASSET__WXs04jze__"